import { useContext } from "react";

import { AuthContext } from "../auth-provider";

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuthContext must be used within an AuthContext.Provider");
  }
  return ctx;
}
